import React, { useEffect, useRef } from "react";

const CursorFollow = () => {
  const circleRef = useRef(null); // Reference to the circle div
  let shrinkTimeout; // Timeout for shrinking the circle

  useEffect(() => {
    const handleMouseMove = (event) => {
      if (!circleRef.current) return;

      // Move the circle to follow the cursor
      circleRef.current.style.left = `${event.clientX - 30}px`; // Adjust to center
      circleRef.current.style.top = `${event.clientY - 30}px`;

      // Expand the circle
      circleRef.current.style.transform = "scale(0.8)";
      circleRef.current.style.opacity = "1";

      // Clear any previous shrink timeout
      clearTimeout(shrinkTimeout);

      // Shrink the circle after 300ms of no movement
      shrinkTimeout = setTimeout(() => {
        circleRef.current.style.transform = "scale(0.4)";
      }, 300);
    };

    const handleMouseDown = () => {
      // Change border color to blue on click
      if (circleRef.current) {
        circleRef.current.style.borderColor = "black";
      }
    };

    const handleMouseUp = () => {
      // Change border color back to contrasting color after click
      if (circleRef.current) {
        circleRef.current.style.borderColor = "rgba(0, 0, 0, 0.375)"; // Default to black for better contrast
      }
    };

    // Add event listeners
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mousedown", handleMouseDown);
    document.addEventListener("mouseup", handleMouseUp);

    return () => {
      // Cleanup event listeners
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mousedown", handleMouseDown);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  return <div id="cursor-circle" ref={circleRef}></div>;
};

export default CursorFollow;
